module.exports = __webpack_public_path__ + "static/media/tachometer.b146b975.svg";